import { getQueryDataSource, resetConfig } from "@query-engine-service"
import { IQueryBuilderContext, IQueryDataSource } from "@types"
import { IContextProvider } from "@uxp"
import { prepareSources } from "@utils"

interface QueryEnginServices {
    getQueryDataSourceById: (queryId: string) => Promise<IQueryDataSource>,
    refreshDatasources: () => Promise<void>
}

export const useQueryEngineService = (uxpContext: IContextProvider): QueryEnginServices => {
    /**
     * this is outside the context provider so we are creating a dummy context 
     * we only need the uxpContext here 
     */

    const context: IQueryBuilderContext = { uxpContext: uxpContext }

    return {
        getQueryDataSourceById: async (queryId: string) => {
            const res = await getQueryDataSource(context, queryId)
            if (!res || !res?.source) return null
            const { sources } = prepareSources([res.source], [])
            return sources[0] as IQueryDataSource
        },
        refreshDatasources: async () => {
            return resetConfig(context)
        }
    }
}